import { useState } from "react";
import { Flag, X, Check } from "lucide-react";
import api from "../lib/api";

export const REPORT_REASONS = ["Spam", "Nudity", "Harassment", "Hate speech", "Violence", "Fake account", "Scam", "Other"];

export default function ReportSheet({ user, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    if (!reason || busy) return;
    setBusy(true); setErr("");
    try {
      await api.post(`/users/${user.id}/report`, { reason, note });
      onDone?.();
    } catch (e) {
      setErr(e?.response?.data?.detail || "Could not submit report");
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/70" onClick={onClose} data-testid="report-sheet">
      <div className="w-full max-w-md rounded-t-3xl bg-[#0B0B12] border-t border-white/10 p-5 pb-8 max-h-[85vh] overflow-y-auto" onClick={e=>e.stopPropagation()}>
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-outfit font-bold text-lg flex items-center gap-2"><Flag className="w-5 h-5 text-[#FF7A00]"/>Report @{user.username || user.name}</h3>
          <button onClick={onClose} data-testid="report-close" className="p-1.5 rounded-full bg-white/5"><X className="w-4 h-4"/></button>
        </div>
        <p className="text-xs text-white/60 mb-4">Why are you reporting this account? Admin will review your report.</p>
        <div className="space-y-2 mb-4" data-testid="report-reasons">
          {REPORT_REASONS.map(r => (
            <button key={r} onClick={()=>setReason(r)} data-testid={`report-reason-${r.toLowerCase().replace(/\s+/g,"-")}`}
              className={`w-full flex items-center justify-between p-3 rounded-2xl border text-sm text-left active:scale-[0.99] ${reason === r ? "bg-[#FF7A00]/15 border-[#FF7A00]/60 text-white" : "bg-white/5 border-white/10 text-white/80"}`}>
              {r}
              {reason === r && <Check className="w-4 h-4 text-[#FF7A00]"/>}
            </button>
          ))}
        </div>
        <textarea value={note} onChange={e=>setNote(e.target.value)} maxLength={500} rows={3} data-testid="report-note"
          placeholder="Add more details (optional)"
          className="w-full p-3 rounded-2xl bg-white/5 border border-white/10 text-sm outline-none focus:border-[#FF7A00]/60 mb-3"/>
        {err && <p className="text-xs text-[#FF2A5F] mb-2" data-testid="report-error">{err}</p>}
        <button onClick={submit} disabled={!reason || busy} data-testid="report-submit"
          className="w-full p-3 rounded-2xl bg-[#FF7A00] text-black font-extrabold disabled:opacity-40 active:scale-[0.99]">
          {busy ? "Submitting..." : "Submit Report"}
        </button>
      </div>
    </div>
  );
}
